import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appCopyText]'
})
export class CopyTextDirective {

  constructor(private el: ElementRef) {}

  @HostListener('click')
  public onClick(): void {
    const text = this.el.nativeElement.textContent;
    navigator.clipboard.writeText(text);
  }
}